import { render, staticRenderFns } from "./AddPlaycardButton.vue?vue&type=template&id=dab0cc4c&lang=pug"
import script from "./AddPlaycardButton.vue?vue&type=script&lang=js"
export * from "./AddPlaycardButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports